import React, { useState, useEffect, Fragment } from "react";
import CustomDropdown from "../CustomDropdown/index.jsx";
import "./dynamicForm.scss";
import { cdnImage } from "../../../../Shared/helper/constants.js";

const DynamicForm = ({ formSchema, handleSubmit ,clearFormData,handleBack}) => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [showOptions, setShowOptions] = useState(false);

  // useEffect(() => {
  //   setFormData({})
  // }, [clearFormData])

  // 🔍 Form Validity Checker
  const isFormValid = () => {
    const hasErrors = Object.keys(errors).length > 0;
    const hasEmptyRequiredFields = formSchema.fields.some(
      (field) => field.required && !formData[field.name]?.trim()
    );
    return !hasErrors && !hasEmptyRequiredFields;
  };

  const handleChange = (eventOrValue, fieldName = null) => {
    let name, value;
    const newErrors = { ...errors };

    if (eventOrValue?.target) {
      // Input field
      name = eventOrValue.target.name;
      value = eventOrValue.target.value;
    } else {
      // Dropdown
      name = fieldName;
      value = eventOrValue?.value;
    }
    const field = formSchema.fields.find((f) => f.name === name);
    if (field) {
      const isEmpty = !value?.trim();
      const patternRegex = new RegExp(field.pattern);
      
      if (field.required && isEmpty) {
        newErrors[name] = `${field.label} is required`;
      } else if (name === "installationAddress" || name === "landmark") {
        if (!isEmpty) {
          if (field.minLength && value.length < field.minLength) {
            newErrors[name] =field.errorMessage || `${field.label} must be at least ${field.minLength} characters`;
          }else if (!patternRegex.test(value)) {
            const onlyNumbers = /^[0-9]+$/.test(value);
            const onlySpecialChars = /^[\-/,\s]+$/.test(value);
      
            if (onlyNumbers || onlySpecialChars) {
              let message = "Please enter a valid";
              message += name === "installationAddress" ? " address" : " landmark";
              newErrors[name] = message;
            } else {
              newErrors[name] = field.errorMessage || `Invalid ${field.label}`;
            }
          } else {
            delete newErrors[name]; 
          }
        } else {
          delete newErrors[name]; 
        }
      }
       else {
        if (field.minLength && value.length < field.minLength) {
          newErrors[name] = field.errorMessage || `${field.label} must be at least ${field.minLength} characters`;
        } else if (field.maxLength && value.length > field.maxLength) {
          newErrors[name] = field.errorMessage || `${field.label} must be no more than ${field.maxLength} characters`;
        } else if (field.pattern && !patternRegex.test(value)) {
          newErrors[name] = field.errorMessage || `Invalid ${field.label}`;
        } else {
          delete newErrors[name];
        }
      }
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors(newErrors);
};


  const handleAction = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="dynamic-form">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(formData);
        }}
      >
        <div className="row">
          {!!formSchema?.fields?.length &&
            formSchema.fields
              .sort((a, b) => (a.rank ?? 0) - (b.rank ?? 0))
              .map((field, index) => (
                <Fragment key={index}>
                  {field.type === "select" ? (
                    <div className="col-md-6">
                      <div class="form-group">
                        <label>{field?.label} {field?.required? <span>*</span>:''}</label>
                        <CustomDropdown
                          options={field.options}
                          placeholder={field.placeholder}
                          onSelect={handleChange}
                          clearSelectedValue={clearFormData}
                          name={field.name}
                        />
                      </div>{" "}
                    </div>
                  ) : (
                    <>
                      <div className="col-md-6">
                        <div class="form-group">
                          <label>{field?.label} {field?.required? <span>*</span>:''}</label>
                          <div className="input-bx">
                            {field.countryCode && (
                              <span className="countryCode">
                                +{field.countryCode}
                              </span>
                            )}
                            <input
                              autoComplete="off"
                              type={field?.type}
                              name={field?.name}
                              placeholder={field.placeholder}
                              value={formData[field.name] || ""}
                              required={field.required}
                              minLength={field.minLength}
                              maxLength={field.maxLength}
                              onChange={handleChange}
                              className="form-control"
                            />
                          </div>
                          {errors[field.name] && (
                            <div className="error">{errors[field.name]}</div>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </Fragment>
              ))}
        </div>
        <div class="button-wrap">
          {!!formSchema.actions.length &&
            formSchema.actions.sort((a, b) => (a.rank ?? 0) - (b.rank ?? 0)).map((action, index) => (
              <button
                className={`${
                  action.type === "cancel" ? "back-button" : "button"
                }`}
                key={index}
                type={action.type === "submit" ? "submit" : "button"}
                onClick={action.type === "submit"
                  ? undefined
                  : action.type === "cancel"
                  ? handleBack
                  : handleAction}
                disabled={action.type === "submit" && !isFormValid()}
              >
                {action.type === "cancel" && (
                  <>
                    {
                      <img
                        // src={`${cdnImage}/assets/images/icons/back-arrow.svg`}
                        src="https://cdn-webportal.airtelstream.net/website/uganda/assets/images/icons/back-arrow.svg"
                        alt={""}
                      />
                    }
                  </>
                )}
                {action.label}{" "}
              </button>
            ))}
        </div>
      </form>
    </div>
  );
};

export default DynamicForm;
